var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 22,
    viewBox: "0 0 40 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_263979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0014 19.219C39.0014 20.478 37.9544 21.499 36.6624 21.499H26.5304C25.2384 21.499 24.1914 20.478 24.1914 19.219C24.1914 15.923 26.9334 13.25 30.3154 13.25H32.8784C36.2594 13.25 39.0014 15.922 39.0014 19.219Z",
    fill: "#A8C7FF",
    stroke: "#0132A2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5967 10.2285C33.8743 10.2285 35.7207 8.38209 35.7207 6.10447C35.7207 3.82685 33.8743 1.98047 31.5967 1.98047C29.319 1.98047 27.4727 3.82685 27.4727 6.10447C27.4727 8.38209 29.319 10.2285 31.5967 10.2285Z",
    fill: "#A8C7FF",
    stroke: "#0132A2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.311 19.219C15.311 20.478 14.264 21.499 12.972 21.499H2.839C1.547 21.499 0.5 20.478 0.5 19.219C0.5 15.923 3.242 13.25 6.624 13.25H9.187C12.569 13.25 15.311 15.922 15.311 19.219Z",
    fill: "#A8C7FF",
    stroke: "#0132A2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90525 10.2285C10.1829 10.2285 12.0292 8.38209 12.0292 6.10447C12.0292 3.82685 10.1829 1.98047 7.90525 1.98047C5.62763 1.98047 3.78125 3.82685 3.78125 6.10447C3.78125 8.38209 5.62763 10.2285 7.90525 10.2285Z",
    fill: "#A8C7FF",
    stroke: "#0132A2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7273 19.0432C27.7273 20.3992 26.5993 21.4992 25.2083 21.4992H14.2963C12.9053 21.4992 11.7773 20.4002 11.7773 19.0432C11.7773 15.4932 14.7303 12.6152 18.3723 12.6152H21.1323C24.7743 12.6162 27.7273 15.4932 27.7273 19.0432Z",
    fill: "#A8C7FF",
    stroke: "#0132A2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7506 9.384C22.2038 9.384 24.1926 7.39525 24.1926 4.942C24.1926 2.48875 22.2038 0.5 19.7506 0.5C17.2973 0.5 15.3086 2.48875 15.3086 4.942C15.3086 7.39525 17.2973 9.384 19.7506 9.384Z",
    fill: "#A8C7FF",
    stroke: "#0132A2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_263979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.5,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTeam);
export default __webpack_public_path__ + "static/media/add_team.59ab1bc21a82c9e56448bed1f820b79e.svg";
export { ForwardRef as ReactComponent };